// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hc5s","badges":"styles_badges__3G1gI"};